import { Redirect } from "react-router";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import useCrew from "../../hooks/useCrew";

const UserOverview = () => {
  const { t } = useTranslation();
  const { crew } = useCrew();

  // show only for admin crew
  if (crew?.id === 0) {
    return <Typography variant="h2">{t("welcome_message")} {t("admin")}</Typography>;
  }

  // redirect to default user's page
  return <Redirect to="/user/compliance/positions" />;
};

export default UserOverview;
